import type { Router } from 'vue-router';
import NProgress from 'nprogress'; // progress bar

import { appRoutes } from '../routes';
import { WHITE_LIST, NOT_FOUND } from '../constants';

export default function setupPermissionGuard(router: Router) {
  router.beforeEach(async (to, from, next) => {
    // 白名单路由直接通过
    if (WHITE_LIST.find((el) => el.name === to.name)) {
      next();
      return;
    }

    // 登录页直接通过
    if (to.name === 'login') {
      next();
      return;
    }

    // 其他路由需要登录状态，由用户登录守卫处理
    // 这里只做基本的权限检查
    next();
  });

  // 添加路由完成后的处理
  router.afterEach(() => {
    NProgress.done();
  });
}
